import angular from 'angular';
import Optimizely from './optimizely';
import service from './activeTest.service';

export default angular.module('cars.activeTest', [
    Optimizely
])

.service('activeTestService', service)

.name;
